import { lazy } from 'react';

export const routerItems = [
  {
    path: '/',
    Component: lazy(() => import('./page/Login'))
  },
  {
    path: '/list',
    Component: lazy(() => import('./page/TenantList'))
  },
  {
    path: '/invite/:id',
    Component: lazy(() => import('./page/Invite'))
  },
  {
    path: '/student-invite/:id',
    Component: lazy(() => import('./page/StudentInvite'))
  },
  {
    path: '/org-invite-student',
    Component: lazy(() => import('./page/OrgInviteStudent'))
  },
  {
    path: '/mobile/:app_key/:page_name',
    Component: lazy(() => import('./page/View/mobile'))
  },
  {
    path: '/pc/:app_key/:page_name',
    Component: lazy(() => import('./page/View/pc'))
  },
  {
    path: '/privacy_pc',
    Component: lazy(() => import('./page/Privacy'))
  },
  {
    path: '/privacy_ios',
    Component: lazy(() => import('./page/Privacy/ios'))
  },
  {
    path: '/privacy_android',
    Component: lazy(() => import('./page/Privacy/android'))
  },
  {
    path: '/privacy_h5',
    Component: lazy(() => import('./page/Privacy/h5'))
  },
  {
    path: '/privacy_harmony',
    Component: lazy(() => import('./page/Privacy/harmony'))
  },
  {
    path: '/protocol',
    Component: lazy(() => import('./page/Protocol'))
  },
  {
    path: '/app-download',
    Component: lazy(() => import('./page/AppDownload/AppDownload'))
  },
    {
    path: '/app-enaea-download',
    Component: lazy(() => import('./page/AppDownload/EnaeaAppDownload'))
  },
  {
    path: '/wx-login',
    Component: lazy(() => import('./page/Login/WeixinLogin'))
  },
  {
    path: '/pay/:id',
    Component: lazy(() => import('./page/Pay/Pay'))
  },
  {
    path: '/wx-code',
    Component: lazy(() => import('./page/WxCode'))
  },
  {
    path: '/wx-share',
    Component: lazy(() => import('./page/WxShare'))
  },
  {
    path: '/wx-pay',
    Component: lazy(() => import('./page/WxPay'))
  },
  {
    path: '/wx-redirect',
    Component: lazy(() => import('./page/WxShare/wxRedirect'))
  },
  {
    path: '/certificate-verification',
    Component: lazy(() => import('./page/CertificateVerification'))
  },
  {
    path: '/year-report-base',
    Component: lazy(() => import('./page/YearReport'))
  },
  {
    path: '/tongda-download',
    Component: lazy(() => import('./page/tongdaDownload'))
  }
];
